import {FetchStatus} from '../common/FetchStatus.enum';
import useTypedSelector from '../common/useTypedSelector';
import {LayoutEntity} from './types';

export function useSelectLayout(id: string): {
  layout?: LayoutEntity;
  fetchStatus: FetchStatus;
  error: Error;
} {
  const result = useTypedSelector(state => {
    const layout = state.pagewebLayout.entities.layouts[id];
    const fetchStatus = state.pagewebLayout.fetchStatus[id];
    const error = state.pagewebLayout.errors[id];
    return {
      layout,
      fetchStatus,
      error,
    };
  });
  return result;
}
